var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useEffect, useMemo } from "react";
import { Box, Text } from "@costar/theme-ui";
import { CoStar } from "@costar-gen/data-services-pds/types";
import { useUpdateLookupInfo } from "@costar-search-x/core";
import { AutoComplete, isOnBlurValueEqualToSelectedValue, isOptionEqualToValue_matchId, } from "../";
var bogusMatchType = 999999;
var bogusMatchId = 999999;
var PlaceHolder = function (props) {
    var message = props.message, rest = __rest(props, ["message"]);
    var onMouseDown = useCallback(function (event) {
        // Prevent input blur when interacting with the "no options" content
        event.preventDefault();
    }, []);
    return (React.createElement(Box, __assign({ backgroundColor: "neutral.light", onMouseDown: onMouseDown }, rest),
        React.createElement(Box, { px: "md", py: "sm", fontSize: "xs", color: "text", opacity: "0.75" },
            React.createElement(Text, null, message))));
};
export var LocationsAutoComplete = function (props) {
    var selectedSearchTerm = props.selectedSearchTerm, matchTypes = props.matchTypes, getOptions = props.getOptions, onChange = props.onChange, messages = props.messages, placeDetailFetcher = props.placeDetailFetcher, clearBogusSearchTerm = props.clearBogusSearchTerm, rest = __rest(props, ["selectedSearchTerm", "matchTypes", "getOptions", "onChange", "messages", "placeDetailFetcher", "clearBogusSearchTerm"]);
    var updateLookupInfo = useUpdateLookupInfo();
    useEffect(function () {
        if (clearBogusSearchTerm && updateLookupInfo) {
            updateLookupInfo(bogusMatchType, bogusMatchId, { name: "" });
        }
    }, [clearBogusSearchTerm, updateLookupInfo]);
    var myGetOptions = useCallback(function (term) { return getOptions(term, matchTypes); }, [getOptions, matchTypes]);
    var onChangeWithFreeSoloUpdate = useCallback(function (_event, newValue, reason) {
        if (typeof newValue === "string" || !newValue) {
            return onChange({ _event: _event, newValue: newValue, reason: reason });
        }
        if (typeof newValue !== "string" && (newValue === null || newValue === void 0 ? void 0 : newValue.value)) {
            var _a = newValue.value, MatchType = _a.MatchType, PlaceId = _a.PlaceId;
            if (MatchType === 12 /* CoStar.Api.Lookup.MatchType.GeocodeResult */) {
                onChange({ _event: _event, newValue: newValue, reason: reason });
                placeDetailFetcher(PlaceId).then(function (res) {
                    var _a;
                    var resLocation = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.items[0].Location;
                    newValue.value.Location = resLocation;
                    return onChange({ _event: _event, newValue: newValue, reason: reason });
                });
            }
            else {
                return onChange({ _event: _event, newValue: newValue, reason: reason });
            }
        }
    }, [onChange, placeDetailFetcher]);
    var m = useMemo(function () { return ({
        noResults: messages.noResults,
        inputPlaceholderText: messages.inputPlaceholderText,
        loading: messages.loading,
    }); }, [messages]);
    var placeHolder = useCallback(function (props) { return React.createElement(PlaceHolder, __assign({ message: messages === null || messages === void 0 ? void 0 : messages.placeholderRenderTitle }, props)); }, [messages === null || messages === void 0 ? void 0 : messages.placeholderRenderTitle]);
    return (React.createElement(AutoComplete, __assign({ value: selectedSearchTerm, getOptions: myGetOptions, onChange: onChangeWithFreeSoloUpdate, messages: m, isOnBlurValueEqualToSelectedValue: isOnBlurValueEqualToSelectedValue, isOptionEqualToValue: isOptionEqualToValue_matchId, renderPlaceHolder: (messages === null || messages === void 0 ? void 0 : messages.placeholderRenderTitle) ? placeHolder : undefined, doNotFilterOptions: true }, rest)));
};
//# sourceMappingURL=LocationsAutoComplete.js.map